/**
 * The one centred column: sign in, register, and the two pages of the password
 * reset. No rail — nobody is signed in yet — and the only place in the whole app
 * where the product explains itself in a sentence.
 */
import type { ReactNode } from 'react';
import { useT } from '../i18n';
import { Brand } from './Brand';

export function AuthLayout({
  title,
  lead,
  tagline = false,
  children,
}: {
  title: string;
  lead?: string;
  /** `/login` and `/register` only: the product's one line about itself */
  tagline?: boolean;
  children: ReactNode;
}) {
  const t = useT();
  return (
    <div className="ae-centre">
      <div className="ae-centre-brand">
        <Brand size="lg" />
      </div>
      {tagline ? <p className="ae-centre-lead">{t('auth.tagline')}</p> : null}
      <h1 className="ae-centre-title">{title}</h1>
      {lead ? <p className="ae-centre-lead">{lead}</p> : null}
      {children}
    </div>
  );
}
